import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const dictionaryProofApi = generateProofApi('/proof-file/dictionary');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('dictionary', dictionaryProofApi);

export function getDictionaryProofsByOwnerOptions(dictionaryId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(dictionaryId, userId);
}

export function getDictionaryProofsOptions(dictionaryId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(dictionaryId);
}

export function useUploadOrUpdateDictionaryProof(dictionaryId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(dictionaryId, queryClient));
}

export function useDeleteDictionaryProof(dictionaryId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(dictionaryId, queryClient));
}
